import React from "react";
import { Container } from "react-bootstrap";
import ScrollSpy from "react-ui-scrollspy";
import MenuNavigation from "../navigation/MenuNavigation.js";
import ProductCategory from "./ProductCategory.js";
import ProductCategoryLoader from "./ProductCategoryLoader.js";
import ProductModal from "../product-modal/ProductModal.js";
import LocationAlertModal from "../../../common/ui/LocationAlertModal.js";
import ErrorModal from "../../../common/ui/ErrorModal.js";
import OfflineModal from "../../../common/ui/OfflineModal.js";
import WardModal from "../ward-modal/WardModal.js";
import "../../../index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import {ReactComponent as S8PoweredByLogo} from "../../../images/S8PoweredLogo_Black.svg";

export default function MenuPage(props) {

  // Publishes the sticky header's height as --s8HeaderHeight so the category strip
  // can stick directly below it. The header height varies by mode (the pickup/delivery
  // switch and delivery estimate each add a row), so a hardcoded offset overlaps or gaps.
  React.useEffect(() => {
    const header = document.querySelector("header");
    if (!header) return;
    const setHeaderHeight = () => document.documentElement.style.setProperty("--s8HeaderHeight", `${header.offsetHeight}px`);
    setHeaderHeight();
    const resizeObserver = new ResizeObserver(setHeaderHeight);
    resizeObserver.observe(header);
    return () => resizeObserver.disconnect();
  }, []);

  // Scroll Spy Items
  const scrollSpyProdCatItems = props.productData.map((item, index) => {
    return (
      <a 
        key={item.productCategoryId}
        href={`#prodcat${item.productCategoryId}`}
        id={`scrollspyprodcat${item.productCategoryId}`}
        className="my-2 mx-3 mx-md-0 text-decoration-none scrollspySelector"
        data-to-scrollspy-id={`prodcat${item.productCategoryId}`}
        onClick={props.handleScrollspySelectorClick}
        style={{padding: "5px 10px"}}
        >
        <small className="fw-medium text-secondary">{item.productCategoryName}</small>
      </a>
    )
  })
  
  // Scroll Spy Container
  const scrollSpyProdCat = 
  <nav id="navScrollSpyBtns" className="navbar navbar-light pb-0 w-100 100vh overflow-auto scrollSpyResponsiveParent">
      <nav className="nav nav-pills flex-md-column flex-nowrap scrollSpyResponsive pe-2">
        {scrollSpyProdCatItems}
        <div className="d-none d-md-flex flex-row justify-content-center mt-auto pt-5 pb-4">
            <a href="https://www.shift8.com/" target="_blank" rel="noreferrer">
              <svg role="img" width="80px" height="28px" alt="Powered by Shift8" aria-labelledby="Powered by Shift8">
                  <title>Powered by Shift8</title>
                  <S8PoweredByLogo />
              </svg>
            </a>
        </div>
      </nav>
    </nav>

  // Menu Product Category & Products
  const productCategoryMenu = props.productData.map(item => {
    return (
      <ProductCategory
      key={item.productCategoryId} 
      data={item}
      handleProductMenuClick={props.handleProductMenuClick}
      />
    );
  });

  // Container (Scroll Spy and Products)
  const productMenu = 
    <>
      <div className="row">
        <div className="col-md-2 d-flex flex-md-column flex-row scrollSpyResponsiveGrandparent bg-white px-0 px-md-2">{scrollSpyProdCat}</div>
        <div className="col-md-10" data-bs-spy="scroll" data-bs-target="#navScrollSpyBtns" data-bs-smooth-scroll="true" data-bs-offset="100" tabIndex="0" >
          <ScrollSpy useBoxMethod={true} offsetTop={0} scrollThrottle={300}>
            {productCategoryMenu}
          </ScrollSpy>
          <div className="d-flex d-md-none flex-row justify-content-center pt-4 pb-4">
              <a href="https://www.shift8.com/" target="_blank">
                <svg role="img" width="80px" height="28px" alt="Powered by Shift8" aria-labelledby="Powered by Shift8">
                    <title>Powered by Shift8</title>
                    <S8PoweredByLogo />
                </svg>
              </a>
          </div>
        </div>
      </div>
    </>;
  
  return (
    <>
      <MenuNavigation 
        data={props.fullMenuData} 
        getGeoLocation={props.getGeoLocation} 
        locationList={props.locationList} 
        locationLoading={props.locationLoading} 
        locationSearchInputRef={props.locationSearchInputRef}
        handleFocusSearchLocation={props.handleFocusSearchLocation}
        handleSearchLocation={props.handleSearchLocation}
        handleClearSearchLocation={props.handleClearSearchLocation}
        handleToggleOpenLocation={props.handleToggleOpenLocation}
        handleSelectLocation={props.handleSelectLocation} 
        currentLocation={props.currentLocation}
        showLocModal={props.showLocModal}
        handleShowLocModal={props.handleShowLocModal}
        handleCloseLocModal={props.handleCloseLocModal}
        locationError={props.locationError}
        menuError={props.menuError}
        amountInCart={props.amountInCart}
        handleViewCart={props.handleViewCart}
        urlConfig={props.urlConfig}
        // Pickup - Shown in Location
        handleBackPickupLocationsToMethodClick={props.handleBackPickupLocationsToMethodClick}
        // --- Pickup / Delivery ---
        pickupOrDelivery={props.pickupOrDelivery}
        handleSelectMethodPickupDeliveryModal={props.handleSelectMethodPickupDeliveryModal}
        handleBackAddressToMethodClick={props.handleBackAddressToMethodClick}
        handleChangeAddressFields={props.handleChangeAddressFields}
        handleSubmitAddressFields={props.handleSubmitAddressFields}
        handlePickupDeliverySwitch={props.handlePickupDeliverySwitch}
        handleCloseMethodChangeModal={props.handleCloseMethodChangeModal}
        handleConfirmMethodChange={props.handleConfirmMethodChange}
        // --- Loyalty Member ---
        loyaltyMember={props.loyaltyMember}
        handleClickOpenLoyaltyModal={props.handleClickOpenLoyaltyModal}
        handleClickCloseLoyaltyModal={props.handleClickCloseLoyaltyModal}
        // Login Page
        handleClickLoginLoyaltyMobile={props.handleClickLoginLoyaltyMobile}
        // Mobile Page
        handleChangeMobileFields={props.handleChangeMobileFields}
        handleNextValidateMobile={props.handleNextValidateMobile}
        // OTP Page
        handleBackOtpPage={props.handleBackOtpPage}
        handleChangeOtpFields={props.handleChangeOtpFields}
        handleResendOtpToMobile={props.handleResendOtpToMobile}
        handleNextValidateOtp={props.handleNextValidateOtp}
        // Voucher List Page
        handleLoyaltyLogout={props.handleLoyaltyLogout}
        handleSelectVoucher={props.handleSelectVoucher}
        // Item Voucher Parent Page
        handleBackItemVoucherParent={props.handleBackItemVoucherParent}
        handleSelectGroupItemVoucherParent={props.handleSelectGroupItemVoucherParent}
        handleAddVoucherToCartItemVoucherParent={props.handleAddVoucherToCartItemVoucherParent}
        // Item Voucher Product List Page
        handleBackItemVoucherProductList={props.handleBackItemVoucherProductList}
        handleSelectProductItemVoucherProductList={props.handleSelectProductItemVoucherProductList}
        // Item Voucher Child Page
        handleBackItemVoucherChild={props.handleBackItemVoucherChild}
        handleModChangeItemVoucherChild={props.handleModChangeItemVoucherChild}
        handleAddToVoucherItemVoucherChild={props.handleAddToVoucherItemVoucherChild}
      />
      <Container fluid="lg" className="px-3 position-relative">
        {props.productsLoading ? <ProductCategoryLoader
        data={[props]} /> : productMenu}
      </Container>
      <ProductModal 
        // General
        productModalDisplay={props.productModalDisplay}
        addToCartError={props.addToCartError}
        handleAddProductToCart={props.handleAddProductToCart}
        handleProductModalClose={props.handleProductModalClose}
        handleProductFormAddQuantity={props.handleProductFormAddQuantity}
        handleProductFormSubtractQuantity={props.handleProductFormSubtractQuantity}
        currentLocation={props.currentLocation}
        // Product
        productDetails={props.productDetails} 
        productFormData={props.productFormData}
        handleProductFormChange={props.handleProductFormChange}
        handleModFormChange={props.handleModFormChange}
        // Product Combo
        productComboChildDetails={props.productComboChildDetails}
        productComboChildFormData={props.productComboChildFormData}
        handleProductComboChildFormChange={props.handleProductComboChildFormChange}
        handleProductComboModFormChange={props.handleProductComboModFormChange}
        handleProductComboGroupSelect={props.handleProductComboGroupSelect}
        handleBackProductComboGroupSelect={props.handleBackProductComboGroupSelect}
        handleSelectProductInComboList={props.handleSelectProductInComboList}
        handleBackProductComboChild={props.handleBackProductComboChild}
        handleAddToProductCombo={props.handleAddToProductCombo}
        addToProductComboError={props.addToProductComboError}
        // Modifier Combo
        modifierComboDetails={props.modifierComboDetails}
        handleModifierComboSelect={props.handleModifierComboSelect}
        handleBackModifierComboSelect={props.handleBackModifierComboSelect}
        handleModifierComboGroupSelect={props.handleModifierComboGroupSelect}
        handleBackModifierComboGroupSelect={props.handleBackModifierComboGroupSelect}
        handleModifierChangeModComboGroup={props.handleModifierChangeModComboGroup}
        handleModifierComboAddSelectionToGroup={props.handleModifierComboAddSelectionToGroup}
        handleModComboAddComboToProduct={props.handleModComboAddComboToProduct}
        handleRemoveModifierComboFromProduct={props.handleRemoveModifierComboFromProduct}
        errorModifierCombo={props.errorModifierCombo}
      />
      <WardModal
        wardDetails={props.wardDetails}
        handleChangeWardModalFields={props.handleChangeWardModalFields}
        handleSubmitWardFields={props.handleSubmitWardFields}
      />
      <LocationAlertModal
        alertModal={props.alertModal}
        handleConfirmChangeLocation={props.handleConfirmChangeLocation}
        handleCancelChangeLocation={props.handleCancelChangeLocation}
      />
      <ErrorModal
        errorModal={props.errorModal}
        handleCloseErrorModal={props.handleCloseErrorModal}
      />
      <OfflineModal
        offlineModal={props.offlineModal}
        handleCloseOfflineModal={props.handleCloseOfflineModal}
        urlConfig={props.urlConfig}
      />
    </>    
  );
}